/**
 * User: fma
 * Date: 02/01/17
 * Time: 10:10 AM
 */

/**
 * This library holds request wrappers for other pages
 * Custom alerts functions can be used as examples. Send url params and post data as two key value objects.
 * NOTE: Please add informative comments before and after requests of a page to indicate which page/component they
 * belong to.
 * NOTE: DO NOT FORGET TO RETURN REQUEST FOR CHAINING
 * NOTE: Be consistent with function parameters even if they are useless (like url params as first parameter)
 */

import * as _VisibilityScore from './VisibilityScore.js'
import * as _VersionHistory from './VersionHistory.js'
import * as _UserApp from './UserApp.js'
import * as _User from './User.js'
import * as _TopCharts from './TopCharts.js'
import * as _Taxonomy from './Taxonomy.js'
import * as _StoreIntegration from './StoreIntegration.js'
import * as _SlackIntegration from './SlackIntegration.js'
import * as _SearchAds from './SearchAds.js'
import * as _Reviews from './Reviews.js'
import * as _Ratings from './Ratings.js'
import * as _Publisher from './Publisher.js'
import * as _PdfReport from './PdfReport.js'
import * as _Payment from './Payment.js'
import * as _Localization from './Localization.js'
import * as _KeywordLiveSearch from './KeywordLiveSearch.js'
import * as _KeywordGroups from './KeywordGroups.js'
import * as _Keyword from './Keyword.js'
import * as _Integration from './Integration.js'
import * as _Estimation from './Estimation.js'
import * as _CustomProductPages from './CustomProductPages.js'
import * as _CustomAlerts from './CustomAlerts.js'
import * as _CountrySummary from './CountrySummary.js'
import * as _CompetitorGroups from './CompetitorGroups.js'
import * as _CompetitiveOverview from './CompetitiveOverview.js'
import * as _ChartAnnotations from './ChartAnnotations.js'
import * as _CategoryRankings from './CategoryRankings.js'
import * as _Authentication from './Authentication.js'
import * as _AsoReport from './AsoReport.js'
import * as _AppUpdateTimeline from './AppUpdateTimeline.js'
import * as _AppInfo from './AppInfo.js'
import * as _ApiKeys from './ApiKeys.js'
import * as _AdIntelligence from './AdIntelligence.js'
import * as _ActiveUsers from './ActiveUsers.js'

export const ActiveUsers = _ActiveUsers
export const AdIntelligence = _AdIntelligence
export const AsoReport = _AsoReport
export const ApiKeys = _ApiKeys
export const AppInfo = _AppInfo
export const AppUpdateTimeline = _AppUpdateTimeline
export const Authentication = _Authentication
export const CategoryRankings = _CategoryRankings
export const CountrySummary = _CountrySummary
export const CustomAlerts = _CustomAlerts
export const Estimation = _Estimation
export const Integration = _Integration
export const Keyword = _Keyword
export const KeywordGroups = _KeywordGroups
export const KeywordLiveSearch = _KeywordLiveSearch
export const Localization = _Localization
export const Payment = _Payment
export const Publisher = _Publisher
export const Reviews = _Reviews
export const SearchAds = _SearchAds
export const SlackIntegration = _SlackIntegration
export const StoreIntegration = _StoreIntegration
export const TopCharts = _TopCharts
export const User = _User
export const UserApp = _UserApp
export const VersionHistory = _VersionHistory
export const VisibilityScore = _VisibilityScore
export const CustomProductPages = _CustomProductPages
export const CompetitiveOverview = _CompetitiveOverview
export const Ratings = _Ratings
export const ChartAnnotations = _ChartAnnotations
export const PdfReport = _PdfReport
export const CompetitorGroup = _CompetitorGroups
export const Taxonomy = _Taxonomy

export default {
  ActiveUsers,
  AdIntelligence,
  AsoReport,
  ApiKeys,
  AppInfo,
  AppUpdateTimeline,
  Authentication,
  CategoryRankings,
  CountrySummary,
  CustomAlerts,
  Estimation,
  Integration,
  Keyword,
  KeywordGroups,
  KeywordLiveSearch,
  Localization,
  Payment,
  Publisher,
  Reviews,
  SearchAds,
  SlackIntegration,
  StoreIntegration,
  TopCharts,
  User,
  UserApp,
  VersionHistory,
  VisibilityScore,
  CustomProductPages,
  CompetitiveOverview,
  Ratings,
  ChartAnnotations,
  PdfReport,
  CompetitorGroup,
  Taxonomy,
}
